import { useState } from "react";
import { navLinks } from "@/mocks/homeContent";

export default function Header() {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 w-full border-b border-background-200 bg-background-50/95 backdrop-blur">
      <div className="mx-auto flex w-full max-w-[1280px] items-center justify-between gap-4 px-4 py-3 md:px-6 md:py-3.5">
        <a href="#top" className="flex items-center gap-2">
          <span className="font-heading flex h-9 items-center rounded-md bg-primary-500 px-2 text-lg font-black tracking-tight text-background-50">
            69<span className="ml-0.5 inline-block">黑料</span>
          </span>
          <span className="hidden text-xs font-medium text-foreground-500 md:inline-block">
            深挖帖 · 起底档案 · 扒皮现场
          </span>
        </a>

        <nav className="hidden items-center gap-1 lg:flex">
          {navLinks.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className="whitespace-nowrap rounded-full px-3.5 py-2 text-sm text-foreground-700 transition-colors hover:bg-secondary-100 hover:text-foreground-950"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <button
            type="button"
            aria-label="搜索"
            className="flex h-9 w-9 items-center justify-center rounded-md text-foreground-600 transition-colors hover:bg-secondary-100"
          >
            <i className="ri-search-line text-lg" />
          </button>
          <a
            href="#subscribe"
            className="hidden whitespace-nowrap items-center rounded-md bg-primary-500 px-4 py-2 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 sm:inline-flex"
          >
            订阅更新提醒
          </a>
          <button
            type="button"
            aria-label="菜单"
            onClick={() => setOpen((v) => !v)}
            className="flex h-9 w-9 items-center justify-center rounded-md text-foreground-800 transition-colors hover:bg-secondary-100 lg:hidden"
          >
            <i className={`text-xl ${open ? "ri-close-line" : "ri-menu-line"}`} />
          </button>
        </div>
      </div>

      {open && (
        <div className="border-t border-background-200 bg-background-50 lg:hidden">
          <nav className="mx-auto flex w-full max-w-[1280px] flex-col gap-1 px-4 py-3 md:px-6">
            {navLinks.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="flex items-center justify-between rounded-md px-3 py-2.5 text-sm text-foreground-800 hover:bg-secondary-100"
              >
                {l.label}
                <i className="ri-arrow-right-line text-foreground-300" />
              </a>
            ))}
            <a
              href="#subscribe"
              onClick={() => setOpen(false)}
              className="mt-2 inline-flex items-center justify-center rounded-md bg-primary-500 px-4 py-2.5 text-sm font-semibold text-background-50"
            >
              订阅更新提醒
            </a>
          </nav>
        </div>
      )}
    </header>
  );
}